import { put } from "redux-saga/effects"
import Cookies from "js-cookie"

import { setLocalStorage } from "helpers/application"

import { setFormPause } from "../../actions"

import fetchLogin from "./fetch-login"
import responseFailFormActions from "./response-fail-form-actions"
import createSearchParams from "./create-search-params"

// Takes response code to set notification and submit button on Formik if error, otherwise sets cookies
// Returns true if response code is success, else false.
export default function* processCredentital(actions) {
  let values = actions.values
  // Do login
  let loginHash = {
    cart_token: Cookies.get(sl.config.cookies_config.cart_token),
    email: values.email,
    password: values.password,
    remember_me: false,
    wishlist_token: Cookies.get(sl.config.cookies_config.wishlist_token),
  }
  if (Object.keys(values).length != 1 && values.orderNumber) {
    const loginData = createSearchParams(loginHash)
    let loginResult = yield fetchLogin(loginData)
    let userObj = loginResult.ResponseObject
    if (loginResult.ResponseCode != 1) {
      const errorMsg = "Cannot find your account. Please try again."
      const statusMsg = "Login is incorrect. Please try again."
      return responseFailFormActions(
        errorMsg,
        actions.setStatus,
        statusMsg,
        actions.setSubmitting
      )
    } else {
      yield put(setFormPause(true))
      setLocalStorage(userObj.jewlrorders.user, "user_obj", cookie_options)
      let cookie_options = { secure: true }
      // Cookies.set uses SESSION cookies by default, we want this in the scenario of a login
      Cookies.set("jwt", userObj.jwt)
      Cookies.set("jwt_options", cookie_options)
      Cookies.set(
        "access_token",
        userObj.jewlrorders.access_token,
        cookie_options
      )
      Cookies.set(
        "refresh_token",
        userObj.jewlrorders.refresh_token,
        cookie_options
      )
    }
  }
}
